interface PageNavigationItem {
  id: string;
  label: string;
  subNavigation?: PageNavigationItem[];
}

const PageNavigationMenuItem: React.FC<{
  nav: PageNavigationItem;
  activeSection: string;
  scrollToSection: (id: string) => void;
  onItemClick?: () => void;
}> = ({ nav, activeSection, scrollToSection, onItemClick }) => {
  if (nav.subNavigation)
    return (
      <div className="flex flex-col gap-[5px]">
        <div className="flex gap-[5px]">
          <div className="w-[10px] shrink-0" />
          <p className="flex-1 font-['Inter',sans-serif] text-[15px] font-medium md:text-[10px] leading-[1.5] tracking-[-0.11px] text-[#334155]">
            {nav.label}
          </p>
        </div>

        {nav.subNavigation?.map((subNav) => (
          <PageNavigationMenuItem
            key={subNav.id}
            nav={subNav}
            activeSection={activeSection}
            scrollToSection={scrollToSection}
            onItemClick={onItemClick}
          />
        ))}
      </div>
    );

  const isActive = activeSection === nav.id;
  return (
    <button
      key={nav.id}
      onClick={() => {
        scrollToSection(nav.id);
        onItemClick?.();
      }}
      className="flex items-stretch gap-[5px] text-left transition-opacity hover:opacity-70"
    >
      {isActive ? (
        <div className="flex w-[10px] shrink-0 self-stretch items-stretch">
          <div className="w-[5px] rounded-[2px] bg-[#334155]" />
        </div>
      ) : (
        <div className="w-[10px] shrink-0" />
      )}

      <div className="w-[10px] shrink-0" />
      <p className="flex-1 font-['Inter',sans-serif] text-[13px] font-medium md:text-[8px] leading-[1.5] tracking-[-0.088px] text-[#334155]">
        {nav.label}
      </p>
    </button>
  );
};

interface IRightPageNavigationMenuProps {
  navItems: PageNavigationItem[];
  headLabel?: string;
  activeSection: string;
  scrollToSection: (id: string) => void;
  children?: React.ReactNode;
  onItemClick?: () => void;
}

// Navigation Menu Component (reused for desktop and mobile)
const RightPageNavigationMenu: React.FC<IRightPageNavigationMenuProps> = ({
  navItems,
  headLabel,
  activeSection,
  scrollToSection,
  children,
  onItemClick,
}) => {
  return (
    <div className="flex flex-col gap-[5px]">
      {/* Additional menu */}
      {children}

      {headLabel && (
        <div className="flex gap-[5px] pb-[10px]">
          <div className="w-[10px] shrink-0" />
          <p className="flex-1 font-['Inter',sans-serif] text-[15px] font-bold md:text-[10px] leading-[1.5] tracking-[-0.11px] text-[#334155]">
            {headLabel}
          </p>
        </div>
      )}

      {navItems.map(
        (nav) => (
          <PageNavigationMenuItem
            key={nav.id}
            nav={nav}
            activeSection={activeSection}
            scrollToSection={scrollToSection}
            onItemClick={onItemClick}
          />
        ),
      )}
    </div>
  );
};

export default RightPageNavigationMenu;

export type { PageNavigationItem, IRightPageNavigationMenuProps };